var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"test",style:(_vm.$store.state.mini?'width:calc(100vw - 168px)':''),attrs:{"id":"treemap"}})])}
var staticRenderFns = []

export { render, staticRenderFns }